import { render, staticRenderFns } from "./doodad.vue?vue&type=template&id=0b69e5af&"
import script from "./doodad.vue?vue&type=script&lang=js&"
export * from "./doodad.vue?vue&type=script&lang=js&"
import style0 from "./doodad.vue?vue&type=style&index=0&id=0b69e5af&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports